import axios from 'axios';
import { dispatch } from 'nike-re-framejs';

import { getUrl } from '@/common/oldMobile';
import { catcher } from '@/_http/utils';
import { ticketStornoOpened, ticketStornoSubmited } from '@/mytickets/storno/handlers';

export const submitStorno = (ticketNumber, branchId, gridChallenge, hash) => {
    axios
        .post(getUrl('TIKET_STORNO'), { ticketNumber, branchId, gridChallenge })
        .then(() => dispatch(ticketStornoSubmited(hash)))
        .catch(catcher.handleMasterError);
};

export const getGrid = () => {
    axios
        .get(getUrl('GRID_STATUS'))
        .then(json => dispatch(ticketStornoOpened(json.gridPosition)))
        .catch(catcher.handleMasterError);
};
